"use strict";
/**
 * This class represents the game.
 * Now it has a basic structure, that is needed for testing.
 * Feel free to add more props and methods if needed.
 */ class $a5fd07fa01589658$var$Game {
    constructor(initialState){
        this.board = initialState || [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
    // #region addRandomCell
    addRandomCell() {
        const clearBoard = [];
        for(let i = 0; i < this.board.length; i++){
            for(let j = 0; j < this.board[i].length; j++)if (this.board[i][j] === 0) clearBoard.push([
                i,
                j
            ]);
        }
        if (clearBoard.length === 0) return;
        const randomIndex = Math.floor(Math.random() * clearBoard.length);
        const randomCell = clearBoard[randomIndex];
        const randomValue = Math.random() > 0.1 ? 2 : 4;
        this.board[randomCell[0]][randomCell[1]] = randomValue;
    }
    // #endregion
    // #region moveMethods
    moveLeft() {
        if (this.status !== "playing") return;
        let move = false;
        for(let i = 0; i < this.board.length; i++){
            const oldRow = [
                ...this.board[i]
            ];
            const newRow = [];
            for(let j = 0; j < this.board[i].length; j++)if (this.board[i][j] !== 0) newRow.push(this.board[i][j]);
            for(let v = 0; v < newRow.length; v++)if (newRow[v] === newRow[v + 1]) {
                const newValue = newRow[v] * 2;
                newRow.splice(v + 1, 1);
                newRow[v] = newValue;
                this.score += newValue;
                if (newValue === 2048) this.status = "win";
                v++;
            }
            while(newRow.length < 4)newRow.push(0);
            for(let index = 0; index < oldRow.length; index++)if (oldRow[index] !== newRow[index]) {
                move = true;
                break;
            }
            this.board[i] = newRow;
        }
        if (move === true) this.addRandomCell();
        if (this.status === "playing") this.ifLose();
    }
    moveRight() {
        for(let i = 0; i < this.board.length; i++)this.board[i].reverse();
        this.moveLeft();
        for(let i = 0; i < this.board.length; i++)this.board[i].reverse();
    }
    transposeBoard() {
        const newBoard = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        for(let i = 0; i < this.board.length; i++)for(let j = 0; j < this.board[i].length; j++)newBoard[j][i] = this.board[i][j];
        this.board = newBoard;
    }
    moveUp() {
        this.transposeBoard();
        this.moveLeft();
        this.transposeBoard();
    }
    moveDown() {
        this.transposeBoard();
        for(let i = 0; i < this.board.length; i++)this.board[i].reverse();
        this.moveLeft();
        for(let i = 0; i < this.board.length; i++)this.board[i].reverse();
        this.transposeBoard();
    }
    // #endregion
    getScore() {
        return this.score;
    }
    getState() {
        return this.board;
    }
    getStatus() {
        return this.status;
    }
    start() {
        if (this.status !== "idle") return;
        this.status = "playing";
        this.addRandomCell();
        this.addRandomCell();
    }
    ifLose() {
        for(let i = 0; i < this.board.length; i++)for(let j = 0; j < this.board[i].length; j++){
            if (this.board[i][j] === 0) return;
            if (j < 3) {
                if (this.board[i][j] === this.board[i][j + 1]) return;
            }
            if (i < 3) {
                if (this.board[i][j] === this.board[i + 1][j]) return;
            }
        }
        this.status = "lose";
    }
    restart() {
        this.board = [
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ],
            [
                0,
                0,
                0,
                0
            ]
        ];
        this.score = 0;
        this.status = "idle";
    }
}
var $a5fd07fa01589658$export$2e2bcd8739ae039 = $a5fd07fa01589658$var$Game;


"use strict";
const $09e991522ca7e64e$var$game = new (0, $a5fd07fa01589658$export$2e2bcd8739ae039)();
const $09e991522ca7e64e$var$btnStart = document.querySelector("button.start");
const $09e991522ca7e64e$var$allCell = document.querySelectorAll(".field-cell");
const $09e991522ca7e64e$var$myScore = document.querySelector(".game-score");
const $09e991522ca7e64e$var$messageLose = document.querySelector(".message-lose");
const $09e991522ca7e64e$var$messageWin = document.querySelector(".message-win");
const $09e991522ca7e64e$var$messageStart = document.querySelector(".message-start");
const $09e991522ca7e64e$var$bestScoreEl = document.querySelector(".best-score");
let $09e991522ca7e64e$var$bestScore = Number(localStorage.getItem("bestScore")) || 0;
$09e991522ca7e64e$var$bestScoreEl.textContent = $09e991522ca7e64e$var$bestScore;
$09e991522ca7e64e$var$btnStart.addEventListener("click", ()=>{
    if ($09e991522ca7e64e$var$game.getStatus() === "idle") {
        $09e991522ca7e64e$var$game.start();
        $09e991522ca7e64e$var$renderBoard();
        $09e991522ca7e64e$var$myScore.textContent = $09e991522ca7e64e$var$game.getScore();
        $09e991522ca7e64e$var$btnStart.textContent = "Restart";
        $09e991522ca7e64e$var$btnStart.classList.add("restart");
        $09e991522ca7e64e$var$btnStart.classList.remove("start");
    } else {
        $09e991522ca7e64e$var$game.restart();
        $09e991522ca7e64e$var$renderBoard();
        $09e991522ca7e64e$var$myScore.textContent = "0";
        $09e991522ca7e64e$var$btnStart.textContent = "Start";
        $09e991522ca7e64e$var$btnStart.classList.remove("restart");
        $09e991522ca7e64e$var$btnStart.classList.add("start");
        $09e991522ca7e64e$var$messageLose.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.add("hidden");
        $09e991522ca7e64e$var$messageStart.classList.remove("hidden");
    }
});
document.addEventListener("keydown", (e)=>{
    if (e.key === "ArrowUp" || e.key === "ArrowDown" || e.key === "ArrowLeft" || e.key === "ArrowRight") e.preventDefault();
    if (e.key === "ArrowLeft") $09e991522ca7e64e$var$game.moveLeft();
    if (e.key === "ArrowRight") $09e991522ca7e64e$var$game.moveRight();
    if (e.key === "ArrowUp") $09e991522ca7e64e$var$game.moveUp();
    if (e.key === "ArrowDown") $09e991522ca7e64e$var$game.moveDown();
    $09e991522ca7e64e$var$renderBoard();
    $09e991522ca7e64e$var$myScore.textContent = $09e991522ca7e64e$var$game.getScore();
    if ($09e991522ca7e64e$var$game.getScore() > $09e991522ca7e64e$var$bestScore) {
        $09e991522ca7e64e$var$bestScore = $09e991522ca7e64e$var$game.getScore();
        $09e991522ca7e64e$var$bestScoreEl.textContent = $09e991522ca7e64e$var$bestScore;
        localStorage.setItem("bestScore", $09e991522ca7e64e$var$bestScore);
    }
    if ($09e991522ca7e64e$var$game.getStatus() === "win") {
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
    }
    if ($09e991522ca7e64e$var$game.getStatus() === "lose") {
        $09e991522ca7e64e$var$messageStart.classList.add("hidden");
        $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
    }
    if ($09e991522ca7e64e$var$game.getStatus() === "playing") $09e991522ca7e64e$var$messageStart.classList.add("hidden");
});
function $09e991522ca7e64e$var$renderBoard() {
    for(let i = 0; i < $09e991522ca7e64e$var$game.getState().length; i++)for(let j = 0; j < $09e991522ca7e64e$var$game.getState()[i].length; j++){
        const cell = $09e991522ca7e64e$var$allCell[i * 4 + j];
        cell.textContent = "";
        cell.className = "field-cell";
        if ($09e991522ca7e64e$var$game.getState()[i][j] !== 0) {
            cell.textContent = $09e991522ca7e64e$var$game.getState()[i][j];
            cell.classList.add(`field-cell--${$09e991522ca7e64e$var$game.getState()[i][j]}`);
        }
    }
}
const $09e991522ca7e64e$var$btnMobile = document.querySelectorAll(".mobile-controls button");
$09e991522ca7e64e$var$btnMobile.forEach((button)=>{
    button.addEventListener("click", ()=>{
        if ($09e991522ca7e64e$var$game.getStatus() !== "playing") return;
        const direction = button.dataset.move;
        if (direction === "left") $09e991522ca7e64e$var$game.moveLeft();
        if (direction === "right") $09e991522ca7e64e$var$game.moveRight();
        if (direction === "up") $09e991522ca7e64e$var$game.moveUp();
        if (direction === "down") $09e991522ca7e64e$var$game.moveDown();
        $09e991522ca7e64e$var$renderBoard();
        $09e991522ca7e64e$var$myScore.textContent = $09e991522ca7e64e$var$game.getScore();
        if ($09e991522ca7e64e$var$game.getStatus() === "win") {
            $09e991522ca7e64e$var$messageStart.classList.add("hidden");
            $09e991522ca7e64e$var$messageWin.classList.remove("hidden");
        }
        if ($09e991522ca7e64e$var$game.getStatus() === "lose") {
            $09e991522ca7e64e$var$messageStart.classList.add("hidden");
            $09e991522ca7e64e$var$messageLose.classList.remove("hidden");
        }
        if ($09e991522ca7e64e$var$game.getStatus() === "playing") $09e991522ca7e64e$var$messageStart.classList.add("hidden");
    });
});


//# sourceMappingURL=index.302c41d2.js.map
